function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetComponent from "components/core/asset/asset-component";
import Colors from "styles/colors";
import classnames from "classnames";
import { isDarkTheme } from "segments/segments-service";
import { useMemo } from "react";
import Title from "segments/desktop/core-components/title/title";
import DefaultProps from "./default-props";
import { StylesTestimonial } from "./testimonial.scss";
const Testimonial = ({ quote, asset, author, company, backgroundColor })=>{
    const additionalClassName = useMemo(()=>{
        if (!backgroundColor) return;
        return isDarkTheme(backgroundColor) ? "white" : "black";
    }, [
        backgroundColor
    ]);
    return /*#__PURE__*/ _jsx(StylesTestimonial, {
        className: classnames("testimonial", additionalClassName),
        style: {
            backgroundColor: Colors[backgroundColor]
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "content",
            children: [
                /*#__PURE__*/ _jsx(Title, _object_spread({
                    titleClassName: "quote"
                }, quote)),
                /*#__PURE__*/ _jsxs("div", {
                    className: "author",
                    children: [
                        (asset === null || asset === void 0 ? void 0 : asset.src) && /*#__PURE__*/ _jsx(AssetComponent, {
                            image: asset,
                            className: "author-image"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "author-details-container",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "author-name",
                                    children: author
                                }),
                                /*#__PURE__*/ _jsx(Title, _object_spread({
                                    titleClassName: "company"
                                }, company))
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default Testimonial;
Testimonial.defaultProps = DefaultProps;
